<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="商品信息：">
          <el-cascader size="small" v-model="formInline.typeKeyId" :options="goodsTypeList" :props="cascaderProps"
            @change="handleTypeChange" placeholder="请选择商品信息" clearable filterable></el-cascader>
        </el-form-item>
        <el-form-item label="球镜">
          <el-select v-model="formInline.paramsKeyId1" placeholder="请选择球镜" clearable filterable size="small"
            @change="handleParamsChange">
            <el-option v-for="item in qiuJingList" :label="item.paramsValue" :value="item.keyId"
              :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="柱镜">
          <el-select v-model="formInline.paramsKeyId2" placeholder="请选择柱镜" clearable filterable size="small"
            @change="handleParamsChange">
            <el-option v-for="item in zhuJingList" :label="item.paramsValue" :value="item.keyId"
              :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否生成库存">
          <el-select v-model="formInline.isCreateWareHouse" size="small" placeholder="请选择是否生产库存" @change="inputChange">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
          <el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button size="small" type="primary" class="el-icon-magic-stick" @click="handleCreate()">生成库存
          </el-button>
          <my-column-filter :listColumns="listColumns" @hidePop="getCheckBox"></my-column-filter>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
        @selection-change="handleSelectionChange" @handle-command="handleCommand" @rowClick="handleRowClick" border
        :fit="true">
        <el-table-column align="center" slot="isCreateWareHouse" label="是否生成库存" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.isCreateWareHouse == true" class="one_1">
              {{ formatterFre(scope.row.isCreateWareHouse) }}</span>
            <span v-if="scope.row.isCreateWareHouse == false" class="one_2">
              {{ formatterFre(scope.row.isCreateWareHouse) }}</span>
          </template>
        </el-table-column>
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </topTab>
    <createWarehouse ref="createWarehouse"></createWarehouse>
  </div>
</template>

<script>
import {
  GetGoodsInfoPageList,
  GetAllGoodsTypeTreePageList,
  GetGoodsParamsList,
} from "@/api/baseDataApi.js";
import createWarehouse from "./createWarehouse.vue";

export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "商品列表",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      selectionList: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        typeKeyId: "",
        paramsKeyId1: "",
        paramsKeyId2: "",
        isCreateWareHouse: null,
      },
      goodsTypeList: [],
      qiuJingList: [],
      zhuJingList: [],
      cascaderProps: {
        value: "keyId", // 绑定值的属性名
        label: "name", // 显示文本的属性名
        children: "subList", // 子节点的属性名
        checkStrictly: false, // 可以选择任意一级
        expandTrigger: "click", // 展开方式
      },
      columnsData: [], //显示列
      listColumns: [
        {
          prop: "keyId",
          label: "全选",
          align: "center",
          fixed: "left",
          width: "55",
          isKeep: true,
          selection: true,
        },
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "type",
          label: "商品品牌",
          isKeep: true,
          width: "120",
          align: "center",
        },
        {
          prop: "name",
          label: "商品名称",
          minWidth: "180",
          align: "center",
        },
        {
          prop: "unit",
          label: "单位",
          width: "60",
          align: "center",
        },
        {
          prop: "qiuJing",
          label: "球镜",
          width: "80",
          align: "center",
        },
        {
          prop: "zhuJing",
          label: "柱镜",
          width: "80",
          align: "center",
        },
        {
          slot: "isCreateWareHouse",
          label: "是否生成库存",
          align: "center",
        },
        {
          prop: "creator",
          label: "创建人",
          width: "120",
          align: "center",
        },
        {
          prop: "createTime",
          label: "创建时间",
          minWidth: "120",
          align: "center",
        },
        {
          prop: "editor",
          label: "维护人",
          width: "120",
          align: "center",
        },
        {
          prop: "updateTime",
          label: "维护时间",
          minWidth: "120",
          align: "center",
        },
        // {
        // 	operation: true,
        // 	isKeep: true,
        // 	label: '操作',
        // 	btnGroup: [
        // 	{
        // 		icon: "el-icon-delete",
        // 		name: "删除",
        // 		type: "4",
        // 		btnType: 'danger'
        // 	},
        // 	],
        // },
      ],
    };
  },
  // 注册组件
  components: {
    createWarehouse,
  },
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.GetAllGoodsTypeTreePageList();
    this.GetGoodsParamsList();
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    // 是否生成库存
    formatterFre(val) {
      return val == true ? "已生成" : val == false ? "未生成" : "";
    },
    changePages() { },
    handleSelectionChange(val) {
      if (val == null || val == undefined || val.length == 0) {
        this.selectionList = [];
      } else {
        this.selectionList = val.map((item) => item.keyId);
      }
    },
    handleCommand(command) {
      // 1编辑
      switch (command.command) {
        case "4":
          this.deleteInfo(command.rowData);
          break;
        default:
          console.log(command);
      }
    },
    handleRowClick(row) {
      if (row.isCreateWareHouse == true) {
        return;
      }
      this.selectionList.push(row.keyId);
      this.$refs.createWarehouse.showCreateWarehouseDialog(this.selectionList);
    },
    // 生成库存
    handleCreate() {
      if (this.selectionList.length == 0) {
        this.$message({
          type: "info",
          message: "请选择商品！",
        });
        return;
      }
      this.$refs.createWarehouse.showCreateWarehouseDialog(this.selectionList);
    },
    // 获取列表
    getListData() {
      this.loading = true;
      GetGoodsInfoPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 重置
    clearAll() {
      this.$data.formInline = this.$options.data.call(this).formInline;
    },
    // 处理商品类型选择变化
    handleTypeChange(value) {
      if (value && value.length > 0) {
        // 取最后一级的值作为typeKeyId
        this.formInline.typeKeyId = value[value.length - 1];
      } else {
        this.formInline.typeKeyId = "";
      }
      this.search();
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 获取商品类型数据
    GetAllGoodsTypeTreePageList() {
      GetAllGoodsTypeTreePageList({})
        .then((res) => {
          if (res.code == 1) {
            this.goodsTypeList = res.data;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    //获取商品参数信息
    GetGoodsParamsList() {
      GetGoodsParamsList({})
        .then((res) => {
          if (res.code == 1) {
            this.qiuJingList = res.data.filter((item) => item.type == 1);
            this.zhuJingList = res.data.filter((item) => item.type == 2);
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 处理商品参数选择变化
    handleParamsChange(value) {
      this.search();
    },
  },
};
</script>

<style scoped>
.one_1 {
  padding: 2px 20px;
  background: #e6f7ff;
  border: 1px solid #6acaf3;
  color: #56bbfd;
  border-radius: 2px;
}

.one_2 {
  padding: 2px 20px;
  background: #f50707;
  border: 1px solid #dfbce2;
  color: rgb(252, 252, 252);
  border-radius: 2px;
}
</style>